const config = {
    state: {
        url:'',
        old: 'https://file.moobyyoho.com/'
    },
}

export default config;